import { useState } from 'react'
import { signInWithPassword, supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [mode, setMode] = useState('login') // 'login' | 'reset'
  const [resetSent, setResetSent] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await signInWithPassword(email, password)
    if (error) setError(error.message)
    setLoading(false)
  }

  async function handleReset(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`
    })
    if (error) {
      setError(error.message)
    } else {
      setResetSent(true)
    }
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--hemlock-green-dark)',
      padding: '24px'
    }}>
      <div style={{
        background: 'var(--hemlock-white)', borderRadius: 16,
        padding: '48px 40px', width: '100%', maxWidth: 400,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 12,
            background: 'var(--hemlock-green)', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center', marginBottom: 16
          }}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <path d="M14 3L4 8.5V19.5L14 25L24 19.5V8.5L14 3Z" stroke="#C8A96E" strokeWidth="1.5" fill="none"/>
              <path d="M14 3V25M4 8.5L24 19.5M24 8.5L4 19.5" stroke="#C8A96E" strokeWidth="1" opacity="0.5"/>
            </svg>
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 600, color: 'var(--hemlock-green-dark)', marginBottom: 4 }}>
            Hemlock Group
          </h1>
          <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Client portal</p>
        </div>

        {mode === 'login' ? (
          <>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', display: 'block', marginBottom: 6 }}>
                  Email
                </label>
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)}
                  required placeholder="you@company.com"
                  style={{
                    width: '100%', padding: '10px 14px', fontSize: 14,
                    border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
                    outline: 'none', transition: 'border-color .15s'
                  }}
                  onFocus={e => e.target.style.borderColor = 'var(--hemlock-green)'}
                  onBlur={e => e.target.style.borderColor = 'var(--border)'}
                />
              </div>

              <div style={{ marginBottom: 8 }}>
                <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', display: 'block', marginBottom: 6 }}>
                  Password
                </label>
                <input
                  type="password" value={password} onChange={e => setPassword(e.target.value)}
                  required placeholder="••••••••"
                  style={{
                    width: '100%', padding: '10px 14px', fontSize: 14,
                    border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
                    outline: 'none', transition: 'border-color .15s'
                  }}
                  onFocus={e => e.target.style.borderColor = 'var(--hemlock-green)'}
                  onBlur={e => e.target.style.borderColor = 'var(--border)'}
                />
              </div>

              {/* Forgot password link */}
              <div style={{ textAlign: 'right', marginBottom: 20 }}>
                <button
                  type="button"
                  onClick={() => { setMode('reset'); setError('') }}
                  style={{ fontSize: 12, color: 'var(--hemlock-green)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                >
                  Forgot password?
                </button>
              </div>

              {error && (
                <div style={{
                  background: '#FEF2F2', border: '1px solid #FCA5A5', borderRadius: 6,
                  padding: '10px 14px', fontSize: 13, color: '#B91C1C', marginBottom: 16
                }}>
                  {error}
                </div>
              )}

              <button
                type="submit" disabled={loading}
                style={{
                  width: '100%', padding: '11px', fontSize: 14, fontWeight: 500,
                  background: loading ? '#aaa' : 'var(--hemlock-green)',
                  color: 'white', border: 'none', borderRadius: 'var(--radius-sm)',
                  cursor: loading ? 'default' : 'pointer', transition: 'background .15s'
                }}
              >
                {loading ? 'Signing in…' : 'Sign in'}
              </button>
            </form>

            <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--text-muted)', marginTop: 24 }}>
              Access is by invitation only.<br />
              Contact your Hemlock Group consultant for access.
            </p>
          </>
        ) : (
          <>
            {resetSent ? (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 32, marginBottom: 16 }}>📬</div>
                <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--hemlock-green-dark)', marginBottom: 8 }}>Check your inbox</h2>
                <p style={{ fontSize: 13, color: 'var(--text-muted)', lineHeight: 1.6, marginBottom: 24 }}>
                  We sent a password reset link to <strong>{email}</strong>. Check your email and follow the link to set a new password.
                </p>
                <button
                  onClick={() => { setMode('login'); setResetSent(false); setEmail('') }}
                  style={{ fontSize: 13, color: 'var(--hemlock-green)', background: 'none', border: 'none', cursor: 'pointer' }}
                >
                  ← Back to sign in
                </button>
              </div>
            ) : (
              <form onSubmit={handleReset}>
                <h2 style={{ fontSize: 16, fontWeight: 600, color: 'var(--hemlock-green-dark)', marginBottom: 8 }}>Reset your password</h2>
                <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 24, lineHeight: 1.6 }}>
                  Enter your email and we'll send you a link to set a new password.
                </p>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--text-secondary)', display: 'block', marginBottom: 6 }}>
                    Email
                  </label>
                  <input
                    type="email" value={email} onChange={e => setEmail(e.target.value)}
                    required placeholder="you@company.com"
                    style={{
                      width: '100%', padding: '10px 14px', fontSize: 14,
                      border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
                      outline: 'none', transition: 'border-color .15s'
                    }}
                    onFocus={e => e.target.style.borderColor = 'var(--hemlock-green)'}
                    onBlur={e => e.target.style.borderColor = 'var(--border)'}
                  />
                </div>

                {error && (
                  <div style={{
                    background: '#FEF2F2', border: '1px solid #FCA5A5', borderRadius: 6,
                    padding: '10px 14px', fontSize: 13, color: '#B91C1C', marginBottom: 16
                  }}>
                    {error}
                  </div>
                )}

                <button
                  type="submit" disabled={loading}
                  style={{
                    width: '100%', padding: '11px', fontSize: 14, fontWeight: 500,
                    background: loading ? '#aaa' : 'var(--hemlock-green)',
                    color: 'white', border: 'none', borderRadius: 'var(--radius-sm)',
                    cursor: loading ? 'default' : 'pointer', transition: 'background .15s',
                    marginBottom: 16
                  }}
                >
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>

                <div style={{ textAlign: 'center' }}>
                  <button
                    type="button"
                    onClick={() => { setMode('login'); setError('') }}
                    style={{ fontSize: 12, color: 'var(--text-muted)', background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    ← Back to sign in
                  </button>
                </div>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  )
}
